import { useState, useCallback, useEffect } from 'react';
import { getKlarityServiceSpecialtyList } from 'api/ppaOnboarding';
import { IPPAServiceSpecialty } from 'types/ppaOnboarding';

const useGetPPAServiceSpecialtyList = (): [IPPAServiceSpecialty[], boolean, string | undefined, () => void] => {
    const [data, setData] = useState<IPPAServiceSpecialty[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();

    const fetch = useCallback(async () => {
        setLoading(true);
        const res = await getKlarityServiceSpecialtyList();
        if (res && !res.error) {
            setData(res.data.data);
        } else {
            setError(res?.error);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, error, fetch];
};

export default useGetPPAServiceSpecialtyList;
